export default {
    type: {
        label: 'Animation',
        template: 'Select',
        helpText: 'asdf',
        options: [
            { name: 'None', value: '' },
            { name: 'Fade', value: 'fade' },
            { name: 'Fade Up', value: 'fade-up' },
            { name: 'Fade Left', value: 'fade-left' },
            { name: 'Fade Right', value: 'fade-right' },
            { name: 'Fade Down', value: 'fade-down' },
            { name: 'Fade Up Left', value: 'fade-up-left' },
            { name: 'Fade Up Right', value: 'fade-up-right' },
            { name: 'Fade Down Left', value: 'fade-down-left' },
            { name: 'Fade Down Right', value: 'fade-down-right' },
            { name: 'Flip Up', value: 'flip-up' },
            { name: 'Flip Down', value: 'flip-down' },
            { name: 'Flip Left', value: 'flip-left' },
            { name: 'Flip Right', value: 'flip-right' },
            { name: 'Slide Up', value: 'slide-up' },
            { name: 'Slide Down', value: 'slide-down' },
            { name: 'Slide Left', value: 'slide-left' },
            { name: 'Slide Right', value: 'slide-right' },
            { name: 'Zoom In', value: 'zoom-in' },
            { name: 'Zoom In Up', value: 'zoom-in-up' },
            { name: 'Zoom In Down', value: 'zoom-in-down' },
            { name: 'Zoom In Left', value: 'zoom-in-left' },
            { name: 'Zoom In Right', value: 'zoom-in-right' },
            { name: 'Zoom Out', value: 'zoom-out' },
            { name: 'Zoom Out Up', value: 'zoom-out-up' },
            { name: 'Zoom Out Down', value: 'zoom-out-down' },
            { name: 'Zoom Out Left', value: 'zoom-out-left' },
            { name: 'Zoom Out Right', value: 'zoom-out-right' },
        ],
    },
    offset: {
        max: 1000,
        label: 'Offset',
        defaultUnit: 'px',
        template: 'Range',
        defaultValue: 120,
    },
    delay: {
        max: 3000,
        label: 'Delay',
        defaultValue: 0,
        template: 'Range',
        defaultUnit: 'ms',
    },
    duration: {
        max: 3000,
        label: 'Duration',
        template: 'Range',
        defaultUnit: 'ms',
        defaultValue: 400,
    },
    once: {
        label: 'Repeat',
        template: 'Tab',
        inputType: 'boxed',
        defaultValue: 'false',
        options: [
            { label: 'Once', value: 'true' },
            { label: 'Repeat', value: 'false' },
        ],
    },
    mirror: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Animate Out',
        defaultValue: 'false',
        options: [
            { label: 'None', value: 'false' },
            { label: 'Mirror', value: 'true' },
        ],
    },
    easing: {
        label: 'Easing Functions',
        template: 'Select',
        defaultValue: 'ease',
        options: [
            { name: 'none', value: '' },
            { name: 'linear', value: 'linear' },
            { name: 'ease', value: 'ease' },
            { name: 'ease-in', value: 'ease-in' },
            { name: 'ease-out', value: 'ease-out' },
            { name: 'ease-in-out', value: 'ease-in-out' },
            { name: 'ease-in-back', value: 'ease-in-back' },
            { name: 'ease-out-back', value: 'ease-out-back' },
            { name: 'ease-in-out-back', value: 'ease-in-out-back' },
            { name: 'ease-in-sine', value: 'ease-in-sine' },
            { name: 'ease-out-sine', value: 'ease-out-sine' },
            { name: 'ease-in-out-sine', value: 'ease-in-out-sine' },
            { name: 'ease-in-quad', value: 'ease-in-quad' },
            { name: 'ease-out-quad', value: 'ease-out-quad' },
            { name: 'ease-in-out-quad', value: 'ease-in-out-quad' },
            { name: 'ease-in-cubic', value: 'ease-in-cubic' },
            { name: 'ease-out-cubic', value: 'ease-out-cubic' },
            { name: 'ease-in-out-cubic', value: 'ease-in-out-cubic' },
            { name: 'ease-in-quart', value: 'ease-in-quart' },
            { name: 'ease-out-quart', value: 'ease-out-quart' },
            { name: 'ease-in-out-quart', value: 'ease-in-out-quart' },
        ],
    },
    anchorPlacement: {
        template: 'Select',
        label: 'Anchor Placement',
        defaultValue: 'top-bottom',
        options: [
            { name: 'None', value: '' },
            { name: 'Top', value: 'top-top' },
            { name: 'Bottom', value: 'bottom-bottom' },
            { name: 'Center', value: 'center-center' },
            { name: 'Top Bottom', value: 'top-bottom' },
            { name: 'Top Center', value: 'top-center' },
            { name: 'Center Bottom', value: 'center-bottom' },
            { name: 'Center Top', value: 'center-top' },
            { name: 'Bottom Center', value: 'bottom-center' },
            { name: 'Bottom Top', value: 'bottom-top' },
        ],
    },
};
